import React from "react";
import { Button, makeStyles, Radio, TextField } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import {
  buyTicket,
  getTicketInvoice,
} from "../../SearchPage/_redux/searchCrud";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Tabs,
  Tab,
} from "@material-ui/core";
import ReactLoading from "react-loading";
import { useMediaQuery } from "react-responsive";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { TabPanel } from "@material-ui/lab";
import { actions } from "../../SearchPage/_redux/searchRedux";
import { actions as authActions } from "../../Auth/_redux/authRedux";
import {
  login,
  loginWithMobile,
  SignInWithMobile,
  VerifyLogin,
  VerifyRegister,
} from "../../Homepage/pages/widgets/components/cruds";
import ReactCodeInput from "react-code-input";
import Countdown from "react-countdown";
import { LinearProgress } from "@material-ui/core";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AuthDialog = (props) => {
  const propsz = {
    className: "class-Input",
    inputStyle: {
      textAlign: "center",
      fontFamily: "sans",
      borderRadius: "6px",
      border: "1px solid lightgrey",
      boxShadow: "rgb(0 0 0 / 10%) 0px 0px 10px 0px",
      margin: "4px",
      paddingLeft: "8px",
      paddingRight: "0px",
      width: "10%",
      height: "42px",
      fontSize: "32px",
      boxSizing: "border-box",
      color: "black",
      backgroundColor: "white",
      direction: "ltr",
      flexGrow: 1,
    },
    touch: {
      border: "1px solid green",
    },
    inputStyleInvalid: {
      fontFamily: "monospace",
      margin: "4px",
      MozAppearance: "textfield",
      width: "15px",
      borderRadius: "3px",
      fontSize: "14px",
      height: "26px",
      paddingLeft: "7px",
      backgroundColor: "red",
      color: "red",
      border: "1px solid red",
    },
  };

  const { state } = useSelector((state) => ({
    state: state.search,
  }));

  let { state: authState } = useSelector((state) => ({
    state: state.auth,
  }));

  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState("login");
  const [verifyTime, setVerifyTime] = React.useState(false);
  const [errMessage, setErrMessage] = React.useState(null);
  const [codeErrMessage, setCodeErrMessage] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isLoginLoading, setIsLoginLoading] = React.useState(false);
  const [isPinLoading, setIsPinLoading] = React.useState(false);
  const [display, setDisplay] = React.useState("none");
  const [timeCounter, setTimeCounter] = React.useState(false);
  const [counterRemained, setCounterRemained] = React.useState(120000);


  const useStyles = makeStyles({
    barColorPrimary: {
      background: "red",
    },
  });

  const classes = useStyles();

  const counterRenderer = ({ total }) => {
    setCounterRemained(total)
    const mainMin = 120000;
    const onePercent = mainMin / 100;
    const leftedPercent = Math.floor(total / onePercent);

    return (
      <LinearProgress
        variant="determinate"
        value={leftedPercent}
        dir="ltr"
        style={{ height: "0.7rem", borderRadius: "10px" }}
        className={` w-75 mx-auto`}

      />
    );
  };

  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

  const users = JSON.parse(window.localStorage.getItem("userInformation"));

  const dispatch = useDispatch();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setVerifyTime(false);
    setOpen(false);
  };

  const history = useHistory();

  const splittedURL = history.location.pathname.split("/");

  React.useEffect(() => {
    handleClickOpen();
  }, []);

  return (
    <Formik
      enableReinitialize
      initialValues={{}}
      onSubmit={(values) => {
        if (value === "login") {
          const data = {
            username: values.username,
            password: values.password,
          };
          login(data)
            .then((res) => console.log("res", res))
            .catch((err) => console.log("err", err));
        } else if (value === "register") {
          const data = {
            phone: `${
              +values.phone[0] === 0 ? values.phone : `0${values.phone}`
            }`,
            nationalCode: values.nationalCode,
          };

          SignInWithMobile(data)
            .then((res) => {})
            .catch((err) => console.log("err", err));
        }
      }}
    >
      {({ handleSubmit, setFieldValue, values }) => {
        return (
          <>
            <Dialog
              open={open}
              TransitionComponent={Transition}
              keepMounted
              fullScreen={isMobile ? true : false}
              onClose={handleClose}
              aria-describedby="alert-dialog-slide-description"
            >
              {" "}
              <div className="d-flex justify-content-start container py-2">
                <i
                  className="fa fa-times ebus-primary-color font-20"
                  onClick={() => {
                    setOpen(false);
                  }}
                ></i>
              </div>
              {!verifyTime ? (
                <DialogTitle>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                  >
                    <Tab label="ثبت نام" value="register" />
                    <Tab label="ورود" value="login" />
                  </Tabs>
                </DialogTitle>
              ) : null}
              {!verifyTime ? (
                <>
                  {value === "register" ? (
                    <div
                      className="w-100 d-flex flex-column p-3 my-3"
                      style={{ gap: 20 }}
                    >
                      <h2 className="mx-auto my-2">ثبت نام</h2>
                      <p className="mx-auto my-3">
                        برای ادامه شماره موبایل خود را وارد کنید.
                      </p>
                      <TextField
                        className="w-75 mx-auto my-2"
                        variant="outlined"
                        placeholder="شماره تلفن"
                        onChange={(e) => {
                          setFieldValue("phone", e.target.value);
                        }}
                      />
                      <h5
                        className="mx-auto w-75 d-flex "
                        style={{ color: "red" }}
                      >
                        <i
                          className={`fa fa-exclamation-circle ${
                            errMessage ? "d-block" : "d-none"
                          }`}
                          style={{ color: "red", marginInline: "10px" }}
                        ></i>
                        {errMessage}
                      </h5>
                      <h6 className="mx-auto my-2">
                        استفاده از ایباس به معنی پذیرش قوانین و مقررات این سرویس
                        است.
                      </h6>
                      <div
                        className="d-flex my-3 mx-auto w-75"
                        style={{ justifyContent: "flex-end", gap: 10 }}
                      >
                        <Button
                          className="btn  mx-auto text-white border15 w-100"
                          style={{
                            whiteSpace: "nowrap",
                            backgroundColor: "green",
                            width: "34rem",
                            fontSize: 16,
                            height: "3.5rem",
                          }}
                          onClick={() => {
                            const data = {
                              phone: `${
                                +values.phone[0] === 0
                                  ? values.phone
                                  : `0${values.phone}`
                              }`,
                            };

                            SignInWithMobile(data).then((res) =>
                              setVerifyTime(true)
                            );
                          }}
                        >
                          {isLoading ? (
                            <ReactLoading
                              type={"spin"}
                              color={"white"}
                              height={"12%"}
                              width={"12%"}
                            />
                          ) : (
                            "تایید و دریافت کد"
                          )}
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="w-100 d-flex flex-column p-3 my-3"
                      style={{ gap: 20 }}
                    >
                      <h2 className="mx-auto my-2">ورود</h2>
                      <p className="mx-auto my-3">
                        برای ادامه شماره موبایل خود را وارد کنید.
                      </p>
                      <TextField
                        className="w-75 mx-auto my-2"
                        variant="outlined"
                        placeholder="شماره تلفن"
                        onChange={(e) => {
                          setFieldValue("phone", e.target.value);
                        }}
                        onKeyUp={(e) => {
                          if (e.which === 13) {
                            const data = {
                              phone: `${
                                +values.phone[0] === 0
                                  ? values.phone
                                  : `0${values.phone}`
                              }`,
                            };
                            setIsLoginLoading(true);
                            loginWithMobile(data)
                              .then((res) => {
                                setVerifyTime(true);
                                setIsLoginLoading(false);
                                setErrMessage(null);
                              })
                              .catch((err) => {
                                setIsLoginLoading(false);

                                if (
                                  err.response.data.message ===
                                  "User not found!"
                                ) {
                                  setErrMessage(
                                    "کاربری با شماره تلفن وارد شده یافت نشد"
                                  );
                                } else {
                                  setErrMessage(
                                    "مشکلی در ارتباط با سرور بوجود آمد"
                                  );
                                }
                              });
                          }
                        }}
                      />
                      <h5
                        className="mx-auto w-75 d-flex "
                        style={{ color: "red" }}
                      >
                        <i
                          className={`fa fa-exclamation-circle ${
                            errMessage ? "d-block" : "d-none"
                          }`}
                          style={{ color: "red", marginInline: "10px" }}
                        ></i>
                        {errMessage}
                      </h5>
                      <div
                        className="d-flex my-3 mx-auto w-75"
                        style={{ justifyContent: "flex-end", gap: 10 }}
                      >
                        <Button
                          className="btn  mx-auto text-white border15 w-100"
                          style={{
                            whiteSpace: "nowrap",
                            backgroundColor: "green",
                            width: "34rem",
                            fontSize: 16,
                            height: "3.5rem",
                          }}
                          onClick={() => {
                            const data = {
                              phone: `${
                                +values.phone[0] === 0
                                  ? values.phone
                                  : `0${values.phone}`
                              }`,
                            };
                            setIsLoginLoading(true);

                            loginWithMobile(data)
                              .then((res) => {
                                setVerifyTime(true);
                                setErrMessage(null);
                                setIsLoginLoading(false);
                              })
                              .catch((err) => {
                                setIsLoginLoading(false);

                                if (
                                  err.response.data.message ===
                                  "User not found!"
                                ) {
                                  setErrMessage(
                                    "کاربری با شماره تلفن وارد شده یافت نشد"
                                  );
                                } else {
                                  setErrMessage(
                                    "مشکلی در ارتباط با سرور بوجود آمد"
                                  );
                                }
                              });
                          }}
                        >
                          {isLoginLoading ? (
                            <ReactLoading
                              type={"spin"}
                              color={"white"}
                              height={"12%"}
                              width={"12%"}
                            />
                          ) : (
                            "تایید و دریافت کد"
                          )}
                        </Button>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div
                  className="w-100 d-flex flex-column p-3 my-3"
                  style={{ gap: 20 }}
                >
                  <h2 className="mx-auto my-2">کد را وارد کنید</h2>
                  <p className="mx-auto w-75" style={{ fontSize: "14px" }}>
                    کد 6 رقمی به شماره {values.phone} ارسال شد.
                  </p>
                  <div
                    className="mx-auto w-75"
                    onKeyUp={(e) => {
                      if (e.which === 13) {
                        const data = {
                          phone: `${
                            +values.phone[0] === 0
                              ? values.phone
                              : `0${values.phone}`
                          }`,
                          code: values.code,
                        };

                        setIsPinLoading(true);

                        const srcId = +window.localStorage.getItem("srcId");
                        const destId = +window.localStorage.getItem("destId");

                        const buyTicketData = {
                          destTownshipId: srcId,
                          sourceTownshipId: destId,
                          travelId: +splittedURL[5],
                          listOfPassengers: state.fullSeats,
                        };

                        if (value === "register") {
                          VerifyRegister(data)
                            .then((res) => {
                              setIsPinLoading(false);
                              const date = new Date();
                              date.setDate(date.getDate() + 1);
                              const dateOBJ = { date };

                              localStorage.setItem(
                                "tokenExpireTime",
                                JSON.stringify(dateOBJ)
                              );
                              dispatch(authActions.login(res.data.data));
                              setCodeErrMessage(null);
                              window.localStorage.setItem(
                                "userInformation",
                                JSON.stringify(res.data.data)
                              );

                              handleClose();
                              // props.handleComplete();
                            })
                            .catch((err) => {
                              setIsPinLoading(false);

                              if (
                                err.response.data.message ===
                                "code is not valid!"
                              ) {
                                setCodeErrMessage("کد نامعتبر است");
                              } else {
                                setCodeErrMessage(
                                  "مشکلی در ارتباط با سرور بوجود آمد"
                                );
                              }
                            });
                        } else if (value === "login") {
                          VerifyLogin(data)
                            .then((res) => {
                              setIsPinLoading(false);

                              const date = new Date();
                              date.setDate(date.getDate() + 1);
                              const dateOBJ = { date };

                              localStorage.setItem(
                                "tokenExpireTime",
                                JSON.stringify(dateOBJ)
                              );
                              dispatch(authActions.login(res.data.data));
                              window.localStorage.setItem(
                                "userInformation",
                                JSON.stringify(res.data.data)
                              );
                              handleClose();
                              // props.handleComplete();
                            })
                            .catch((err) => {
                              setIsPinLoading(false);

                              if (
                                err.response.data.message ===
                                "code is not valid!"
                              ) {
                                setCodeErrMessage("کد نامعتبر است");
                              } else {
                                setCodeErrMessage(
                                  "مشکلی در ارتباط با سرور بوجود آمد"
                                );
                              }
                            });
                        }
                      }
                    }}
                  >
                    <ReactCodeInput
                      {...propsz}
                      type="number"
                      fields={6}
                      onChange={(e) => {
                        setFieldValue("code", e);
                        console.log(e);
                      }}
                    />
                    <h5 className="mt-5 d-flex" style={{ color: "red" }}>
                      <i
                        className={`fa fa-exclamation-circle ${
                          codeErrMessage ? "d-block" : "d-none"
                        }`}
                        style={{ color: "red", marginInline: "10px" }}
                      ></i>
                      {codeErrMessage}
                    </h5>
                    <Countdown
                      date={Date.now() + counterRemained}
                      renderer={counterRenderer}
                    />
                  </div>
                  <div
                    className="d-flex my-3 mx-auto w-75"
                    style={{ justifyContent: "flex-end", gap: 10 }}
                  >
                    <Button
                      className="btn  mx-auto text-white border15 w-100"
                      style={{
                        whiteSpace: "nowrap",
                        backgroundColor: "green",
                        width: "34rem",
                        fontSize: 16,
                        height: "3.5rem",
                      }}
                      onClick={() => {
                        const data = {
                          phone: `${
                            +values.phone[0] === 0
                              ? values.phone
                              : `0${values.phone}`
                          }`,
                          code: values.code,
                        };

                        const buyTicketData = {
                          destTownshipId: +splittedURL[5],
                          sourceTownshipId: +splittedURL[4],
                          travelId: +splittedURL[5],
                          listOfPassengers: state.fullSeats,
                        };

                        setIsPinLoading(true);

                        if (value === "login") {
                          VerifyLogin(data)
                            .then((res) => { 
                              setIsPinLoading(false);

                              const date = new Date();
                              date.setDate(date.getDate() + 1);
                              const dateOBJ = { date };

                              localStorage.setItem(
                                "tokenExpireTime",
                                JSON.stringify(dateOBJ)
                              );
                              dispatch(authActions.login(res.data.data));
                              window.localStorage.setItem(
                                "userInformation",
                                JSON.stringify(res.data.data)
                              );
                              setCodeErrMessage(null);
                              handleClose();
                            })
                            .catch((err) => {
                              setIsPinLoading(false);

                              if (
                                err.response.data.message ===
                                "code is not valid!"
                              ) {
                                setCodeErrMessage("کد نامعتبر است");
                              } else {
                                setCodeErrMessage(
                                  "مشکلی در ارتباط با سرور بوجود آمد"
                                );
                              }
                            });
                        } else if (value === "register") {
                          VerifyRegister(data)
                            .then((res) => {
                              setIsPinLoading(false);

                              const date = new Date();
                              date.setDate(date.getDate() + 1);
                              const dateOBJ = { date };

                              localStorage.setItem(
                                "tokenExpireTime",
                                JSON.stringify(dateOBJ)
                              );
                              dispatch(authActions.login(res.data.data));
                              window.localStorage.setItem(
                                "userInformation",
                                JSON.stringify(res.data.data)
                              );
                              setCodeErrMessage(null);
                              handleClose();
                            })
                            .catch((err) => {
                              setIsPinLoading(false);

                              if (
                                err.response.data.message ===
                                "code is not valid!"
                              ) {
                                setCodeErrMessage("کد نامعتبر است");
                              } else {
                                setCodeErrMessage(
                                  "مشکلی در ارتباط با سرور بوجود آمد"
                                );
                              }
                            });
                        }
                      }}
                    >
                      {isPinLoading ? (
                        <ReactLoading
                          type={"spin"}
                          color={"white"}
                          height={"12%"}
                          width={"12%"}
                        />
                      ) : (
                        "تایید"
                      )}
                    </Button>
                  </div>
                </div>
              )}
            </Dialog>
          </>
        );
      }}
    </Formik>
  );
};

export default AuthDialog;
